// extracted by mini-css-extract-plugin
module.exports = {"root":"DesktopView_root__3E1kL","columns":"DesktopView_columns__U6o3J","sideColumn":"DesktopView_sideColumn__2muUL","centerColumn":"DesktopView_centerColumn__5ozVN"};